import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { colors } from '../../../../../../shared/styles/colors'

interface ITextProps {
  $fontSize: string
  $fontWeight:
    | 'normal'
    | 'bold'
    | 'bolder'
    | 'lighter'
    | 'initial'
    | '100'
    | '200'
    | '300'
    | '400'
    | '500'
    | '600'
    | '700'
    | '800'
    | '900'
  $color: string
}

export const StyledGrid = styled(Grid)`
  width: 512px;
  display: flex;
  flex-direction: column;
  margin-bottom: 4px !important;
  margin-top: 4px !important;
  padding: 0px !important;
  border-radius: 8px !important;
`

export const BoxValor = styled.div`
  background-color: ${colors.gray5};
  font-family: Inter, Roboto, sans-serif;
  text-align: center;
  height: 145px;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
`

export const TextBoleto = styled.span<ITextProps>`
  line-height: 150%;
  font-weight: ${props => props.$fontWeight ?? '600px'};
  font-size: ${props => props.$fontSize ?? '14px'};
  color: ${props => props.$color ?? colors.gray5};
`

export const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: 0.5px solid ${colors.lightGrey};
`
